
const Images = ({ recommendations, similarityDistance }: any) => {
    const env = localStorage.getItem("clientName")
    return (
        <>
            <div className="row">
                <div className="col-sm-12 recommended-heading">
                    <p><b>Recommended Products</b> (with similarity percentage):</p>
                </div>
            </div>
            <div className="row eq-height">
                {recommendations.map(function (x: any, i: any) {
                    return (<div className="col-md-6 col-lg-4 col-xl-3" key={i}>
                        <div className="lens-other-products" style={{height: "221px", width: "221px", display: "flex"}}>
                            <img
                                // src={`https://shoptalk.rysun.com/Recommendation_Engine/${x}`}
                                src={`${process.env.REACT_APP_IMAGE}${env === "RRU" ? "RRucommendation_Engine" :"Recommendation_Engine"}/${x}`}
                                className="img-fluid bg-white"
                                // height={245}
                                // width={245}
                                alt='suggested-images'
                            />
                            <span className="similar-percentage">{Number(similarityDistance[i])?.toFixed(2)}%</span>
                        </div>
                    </div>)
                })}

            </div>

        </>
    );
};

export default Images